export const IDDOC_SELECT_MODAL = 'OrderAddIDDocSelectModal'
export const CLIENT_SEARCH_NAME = 'OrderAddClientSearch'
export const DELEGATE_SELECT_MODAL = 'OrderAddDelegateSelectModal'

export const accountsNames = {
  debit: {
    accNo: 'DebitAccNo',
    chosenAccNo: 'DebitChosenAccNo',
    accID: 'DebitAccID',
    accHash: 'DebitAccHash',
    accTitle: 'DebitTitleUNI',
    accBalance: 'DebitAccBalance',
  },

  credit: {
    accNo: 'CreditAccNo',
    chosenAccNo: 'CreditChosenAccNo',
    accID: 'CreditAccID',
    accHash: 'CreditAccHash',
    accTitle: 'CreditTitleUNI',
    accBalance: 'CreditAccBalance',
  },
}

export const maskForRequiredFields = {
  IND_Name: 'Name',
  IND_Surname: 'Surname',
  IND_DOB: 'DOB',
  Address: 'Address',
  CityID: 'CityID',
  CardNumber: 'CardNumber',
  IDCardTypeID: 'IDCardTypeID',
  CitizenshipID: 'CitizenshipID',
  IDCardRegDate: 'IDCardRegDate',
  IDValidityDate: 'IDValidityDate',
  OtherIDNumber: 'OtherIDNumber',
  CellPhone: 'CellPhone',
  IDCardIssuerID: 'IDCardIssuerID',
}

export const DropdownNames = ['CityID', 'IDCardTypeID', 'CitizenshipID', 'IDCardIssuerID']
